<template>
	<section>

        <div class="section-table">
            <pagination
                class="pagination-top"
                :total="logs.total"
                :page.sync="logs.current_page"
                :limit.sync="logs.per_page"
                @pagination="setLogData(false)"
                :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            >
                <el-input style="margin-left: 10px" size="small" v-model="search" placeholder="Search Logs"></el-input>
                <el-button style="margin-left: 10px" v-if="!_.isEmpty(selectedLogs)" type="primary" size="small" @click="replayZaps">Replay Zap/s</el-button>
            </pagination>

            <el-table
                ref="zapLogsTable"
                class="zapLogsTable"
                v-loading="tableLoading"
                :data="tableData"
                stripe
                style="width: 100%"
                :row-key="setRowKeys"
                @selection-change="handleSelectionChange"
                @row-click="
                    (row) => {
                        this.$refs.zapLogsTable.toggleRowExpansion(row)
                    }
                "
                :default-sort="{ prop: 'created_at', order: 'descending' }"
            >
                <el-table-column
                    type="selection"
                    width="55"
                    :selectable="selectableLogs">
                </el-table-column>
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <div class="language-container">
                            <el-button type="primary" size="small" icon="el-icon-scissors" v-clipboard="props.row.payload" class="active copy">
                                Copy
                            </el-button>
                            <pre
                                class="language-json"
                                style="max-height: 600px"
                            ><code class="language-json">{{JSON.parse(props.row.payload, undefined, 2)}}</code></pre>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column sortable prop="zap_name" label="Zap Name" width="250"></el-table-column>

                <el-table-column label="Application ID" width="150">
                    <template slot-scope="props">
                        <span v-if="props.row.application">
                            <a
                                v-if="props.row.application"
                                :href="'/admin/applications/' + props.row.application.id + '/stage/application'"
                                :target="props.row.application.ref_id"
                            >
                                #{{ props.row.application.ref_id }}
                            </a>
                        </span>
                        <span v-else>User Initiated</span>
                    </template>
                </el-table-column>

                <el-table-column sortable prop="description" label="Log Description"></el-table-column>

                <el-table-column sortable prop="initiator" label="Logged By" width="200"></el-table-column>

                <el-table-column
                    fixed="right"
                    sortable
                    prop="created_at"
                    label="Log Date"
                    width="200"
                    :formatter="dateFormatter"
                ></el-table-column>
            </el-table>

            <pagination
                class="pagination-bottom"
                :total="logs.total"
                :page.sync="logs.current_page"
                :limit.sync="logs.per_page"
                @pagination="setLogData(false)"
                :page-sizes="[5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 200, 500]"
            >
                <el-input style="margin-left: 10px" size="small" v-model="search" placeholder="Search Logs"></el-input>
                <el-button style="margin-left: 10px" v-if="!_.isEmpty(selectedLogs)" type="primary" size="small" @click="replayZaps">Replay Zap/s</el-button>
            </pagination>
        </div>
	</section>
</template>

<script>
	import { mapGetters } from "vuex"
	import Pagination from "@shared/components/pagination"

	export default {
		name: "ZapLogs",
		components: {
			Pagination,
		},
		computed: {
			...mapGetters({
				logs: "zapier/getLogs",
				user: "user/user",
			}),
			tableData() {
				// check to see if the required data is loaded
				if (_.isEmpty(this.logs.data) && _.isEmpty(this.user)) return []
				return this.logs.data
			},
		},
		data() {
			return {
				tableLoading: true,
				search: "",
				searchTimeout: null,
				searchTimeoutWait: 1000,
                selectedLogs: []
			}
		},
		mounted() {
			this.setLogData(true)
			this.$store.dispatch("user/saveUser", this.$store.getters.token)
            Echo.private(`zapReport.${Ambition.tenantId()}`).listen(".report", (event) => {
                this.setLogData(true)
            })
		},
        beforeDestroy() {
            Echo.leave(`zapReport.${Ambition.tenantId()}`)
        },
		watch: {
			search: {
				handler() {
					if (this.searchTimeout) clearTimeout(this.searchTimeout)
					this.searchTimeout = setTimeout(() => {
						this.setLogData(true)
					}, this.searchTimeoutWait)
				},
			},
		},
		methods: {
            replayZaps() {
                if (!_.isEmpty(this.selectedLogs)) {
                    let logs = Object.assign({}, this.selectedLogs)
                    this.selectedLogs = []
                    this.$refs.zapLogsTable.clearSelection();
                    this.tableLoading = true
                    this.$store.dispatch("zapier/replayZaps", logs)
                        .then(res => {})
                        .catch(err => console.error(err))
                }
            },
            selectableLogs(row, index) {
                if (row.application_id) return true
                return false
            },
            handleSelectionChange(selected) {
                this.selectedLogs = selected
            },
			setLogData(resetPage) {
				if (resetPage) {
					this.logs.current_page = 1
				}
				let data = {
					logs: this.logs,
					search: this.search,
				}
				this.tableLoading = true
				this.$store.dispatch("zapier/setLogs", data).then((res) => {
					this.tableLoading = false
				})
			},
			// set row keys
			setRowKeys(row) {
				return row.id
			},
			// format date
			dateFormatter(row) {
				let updated = this.$moment.utc(row.updated_at).tz(this.user.timezone)
				if (updated) {
					return updated.format("ddd DD/MM/YY LT")
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.section-table {
		background-color: #f0f3f5;
		border: 1px solid #c2cfd6;
		padding: 10px;

		.pagination-container {
			border: 1px solid #dcdfe6;
			border-radius: 5px;
			padding: 10px !important;

            &.pagination-top {
                margin-bottom: 10px !important;
            }

            &.pagination-bottom {
                margin-top: 10px !important;
                margin-bottom: 0 !important;
            }

			.el-pager {
				li {
					background-color: transparent;
					border: 1px solid #dcdfe6;
					font-weight: 400;

					&.active {
						background-color: #69c23a;
						border: none;
					}
				}
			}
		}

		.el-table {
			border: 1px solid #dcdfe6;
			border-radius: 5px;
		}
	}

	.language-container {
		position: relative;
	}

	.language-container .copy {
		position: absolute;
		right: 20px;
		top: 10px;
	}
</style>
